{
  "v9.factures.abonnement.actif": "Abonnement actif",
  "v9.factures.abonnement.en_retard": "Abonnement en retard",
  "v9.factures.abonnement.impaye": "Abonnement impayé",
  "v9.factures.abonnement.litige": "Litige en cours",
  "v9.factures.abonnement.resilie": "Abonnement résilié",
  "v9.factures.annuler": "Annuler",
  "v9.factures.archive.bouton": "Télécharger l'année {{annee}}",
  "v9.factures.archive.en_cours": "Préparation de l’archive…",
  "v9.factures.archive.erreur": "L'archive n'a pas pu être téléchargée.",
  "v9.factures.archive.succes": "Archive téléchargée.",
  "v9.factures.champ.annee": "Année",
  "v9.factures.champ.recherche": "Numéro ou montant",
  "v9.factures.champ.statut": "Statut",
  "v9.factures.code.ACCES_RESTREINT_IMPAYE": "Accès restreint pour impayé : réglez les factures en retard.",
  "v9.factures.code.CONFIRMATION_IDENTITE_REQUISE": "Confirmez votre identité (valable 5 minutes) avant cette action.",
  "v9.factures.code.CONTEXTE_INCOMPLET": "Aucune organisation n'est associée à votre session.",
  "v9.factures.code.CREANCE_DEJA_IRRECOUVRABLE": "Cette créance est déjà passée en irrécouvrable.",
  "v9.factures.code.DELAI_DE_REFLEXION_EN_COURS": "Auto-approbation : le délai de réflexion n'est pas écoulé.",
  "v9.factures.code.DEVISE_FIGEE": "La devise ne change plus après la première facture : demandez une exception de facturation.",
  "v9.factures.code.DROIT_NON_TENU": "Vous ne tenez pas le droit nécessaire à cette action.",
  "v9.factures.code.FACTURE_DEJA_REGLEE": "Cette facture est déjà réglée.",
  "v9.factures.code.IDEMPOTENCY_CONFLICT": "Ce règlement a déjà été soumis avec une autre demande : rechargez la page.",
  "v9.factures.code.NUMEROTATION_NON_MODIFIABLE": "La séquence ne change plus après la première facture : seul le préfixe des factures futures peut changer.",
  "v9.factures.code.PAIEMENT_REFUSE": "Le prestataire a refusé le paiement : choisissez un autre moyen de paiement.",
  "v9.factures.code.PRESTATAIRE_INDISPONIBLE": "Le prestataire de paiement n'est pas joignable : rien n'a été modifié.",
  "v9.factures.code.PROPRIETAIRE_SEUL": "Réservé au propriétaire de l'organisation.",
  "v9.factures.code.RESOURCE_UNAVAILABLE": "Élément introuvable.",
  "v9.factures.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v9.factures.code.STORAGE_UNAVAILABLE": "Le stockage des documents est indisponible : réessayez plus tard.",
  "v9.factures.code.VALIDATION_ERROR": "Saisie refusée : vérifiez les champs.",
  "v9.factures.code.VALIDATION_PAR_UN_TIERS": "Seconde signature requise : un autre administrateur de la plateforme valide la demande.",
  "v9.factures.code.VERSION_CONFLICT": "Ces informations ont été modifiées entre-temps : rechargez la page avant de recommencer.",
  "v9.factures.colonne.actions": "Actions",
  "v9.factures.colonne.emise_le": "Émise le",
  "v9.factures.colonne.etat": "État",
  "v9.factures.colonne.montant": "Montant",
  "v9.factures.colonne.numero": "Numéro",
  "v9.factures.contester": "Contester ou demander un avoir",
  "v9.factures.coordonnees.adresse": "Adresse de facturation",
  "v9.factures.coordonnees.adresse_invalide": "Une adresse de destinataire est invalide.",
  "v9.factures.coordonnees.destinataires": "Destinataires des factures (séparés par des virgules)",
  "v9.factures.coordonnees.devise": "Devise",
  "v9.factures.coordonnees.devise_figee": "Devise figée après la première facture : changement par une demande d’exception.",
  "v9.factures.coordonnees.enregistrees": "Coordonnées enregistrées.",
  "v9.factures.coordonnees.erreur": "Les coordonnées n'ont pas pu être enregistrées.",
  "v9.factures.coordonnees.factures_futures": "Les modifications s’appliquent aux factures futures seulement.",
  "v9.factures.coordonnees.fiscal_invalide": "Format de l'identifiant fiscal invalide.",
  "v9.factures.coordonnees.identifiant_fiscal": "Identifiant fiscal",
  "v9.factures.coordonnees.pays": "Pays (code à deux lettres)",
  "v9.factures.coordonnees.pays_invalide": "Code pays à deux lettres majuscules.",
  "v9.factures.coordonnees.raison_sociale": "Raison sociale",
  "v9.factures.coordonnees.reference_commande": "Référence de commande",
  "v9.factures.coordonnees.requis": "Champ requis.",
  "v9.factures.coordonnees.rien_a_enregistrer": "Rien à enregistrer : aucune modification.",
  "v9.factures.coordonnees.titre": "Coordonnées de facturation",
  "v9.factures.credit.titre": "Crédit disponible",
  "v9.factures.credit.vide": "Aucun crédit disponible.",
  "v9.factures.demande.aucune": "Aucune demande du propriétaire.",
  "v9.factures.demande.instruire": "Instruire la demande",
  "v9.factures.demande.refuser": "Refuser la demande",
  "v9.factures.demande.titres": "Demandes du propriétaire",
  "v9.factures.document.attestation_fiscale": "Attestation fiscale",
  "v9.factures.document.conditions_de_traitement_des_donnees": "Conditions de traitement des données",
  "v9.factures.document.conditions_en_vigueur": "Conditions générales en vigueur",
  "v9.factures.document.coordonnees_bancaires": "Coordonnées bancaires",
  "v9.factures.documents.erreur": "Le document n'a pas pu être téléchargé.",
  "v9.factures.documents.fichier": "Fichier PDF",
  "v9.factures.documents.fichier_requis": "Choisissez un fichier.",
  "v9.factures.documents.nature": "Nature du document",
  "v9.factures.documents.publie": "Version {{version}} publiée.",
  "v9.factures.documents.publier": "Publier une nouvelle version",
  "v9.factures.documents.telecharger": "Télécharger",
  "v9.factures.documents.telecharger_nomme": "Télécharger : {{nom}}",
  "v9.factures.documents.titre": "Documents de la plateforme",
  "v9.factures.documents.version": "version {{version}} du {{date}}",
  "v9.factures.documents.vide": "Aucun document publié.",
  "v9.factures.ecran.dialogue-enregistrer-un-reglement": "Enregistrer un règlement reçu",
  "v9.factures.ecran.organisation-coordonnees-facturation": "Coordonnées de facturation",
  "v9.factures.ecran.organisation-facture-fiche": "Facture",
  "v9.factures.ecran.organisation-factures": "Factures et avoirs",
  "v9.factures.ecran.plateforme-facturation-indicateurs": "Indicateurs de facturation",
  "v9.factures.ecran.plateforme-litige-fiche": "Litige de paiement",
  "v9.factures.ecran.plateforme-organisation-facturation": "Facturation de l'organisation",
  "v9.factures.ecran.plateforme-parametres-facturation": "Paramètres de facturation et de fiscalité",
  "v9.factures.effet_acces.acces_restreint": "Accès restreint",
  "v9.factures.effet_acces.aucun": "Aucun",
  "v9.factures.effet_acces.suspendu_pour_impaye": "Suspendue pour impayé",
  "v9.factures.enregistrement": "Enregistrement…",
  "v9.factures.enregistrer": "Enregistrer",
  "v9.factures.etat.chargement": "Chargement : {{quoi}}…",
  "v9.factures.etat.erreur": "Impossible de lire : {{quoi}}.",
  "v9.factures.etat.introuvable": "Introuvable : {{quoi}}.",
  "v9.factures.etat.refus": "Accès refusé.",
  "v9.factures.etat.vide": "Rien à afficher.",
  "v9.factures.etat_facturation.a_jour": "Facturation à jour.",
  "v9.factures.etat_facturation.acces_restreint": "Accès restreint : lecture seule.",
  "v9.factures.etat_facturation.delai_de_grace": "Délai de grâce en cours.",
  "v9.factures.etat_facturation.suspendu_pour_impaye": "Organisation suspendue pour impayé.",
  "v9.factures.etat_facture.avoir": "Avoir",
  "v9.factures.etat_facture.emise": "Émise",
  "v9.factures.etat_facture.en_retard": "En retard",
  "v9.factures.etat_facture.impayee": "Impayée",
  "v9.factures.etat_facture.irrecouvrable": "Irrécouvrable (reste payable)",
  "v9.factures.etat_facture.partiellement_remboursee": "Partiellement remboursée",
  "v9.factures.etat_facture.payee": "Payée",
  "v9.factures.etat_facture.remboursee": "Remboursée",
  "v9.factures.exception.accorder": "Accorder une exception",
  "v9.factures.exception.aucune": "Aucune exception accordée.",
  "v9.factures.exception.titres": "Exceptions accordées",
  "v9.factures.exception.voir": "Voir l'exception",
  "v9.factures.fiche.actions": "Actions sur la facture",
  "v9.factures.fiche.aucune_imputation": "Aucun crédit imputé sur cette facture.",
  "v9.factures.fiche.avoir": "Avoir {{numero}}",
  "v9.factures.fiche.echeance": "Échéance",
  "v9.factures.fiche.facture": "Facture {{numero}}",
  "v9.factures.fiche.ht": "Total HT",
  "v9.factures.fiche.imputation": "Crédit imputé : {{montant}} le {{date}}",
  "v9.factures.fiche.imputations": "Imputations du crédit",
  "v9.factures.fiche.libelle": "Libellé",
  "v9.factures.fiche.lignes": "Lignes de la facture",
  "v9.factures.fiche.navigation": "Navigation",
  "v9.factures.fiche.reste_du": "Reste dû",
  "v9.factures.fiche.taxes": "Taxes",
  "v9.factures.fiche.ttc": "Total TTC",
  "v9.factures.impaye.grace": "Délai de grâce jusqu'au {{date}}.",
  "v9.factures.impaye.lecture_seule": "Accès en lecture seule jusqu'au {{date}}, puis suspension pour impayé.",
  "v9.factures.impaye.titre": "Conséquences de l'impayé",
  "v9.factures.indicateurs.abonnes": "Abonnés par palier",
  "v9.factures.indicateurs.exceptions": "Exceptions accordées",
  "v9.factures.indicateurs.impayes": "Impayés par étape",
  "v9.factures.indicateurs.periode": "Période",
  "v9.factures.indicateurs.resiliations": "Résiliations et motifs",
  "v9.factures.indicateurs.revenus": "Revenus récurrents par devise",
  "v9.factures.indicateurs.vide": "Aucune donnée pour cette période.",
  "v9.factures.irrecouvrable.contresigner": "Contresigner le passage en irrécouvrable",
  "v9.factures.irrecouvrable.demande": "Demande enregistrée : un autre administrateur doit contresigner.",
  "v9.factures.irrecouvrable.demander": "Demander le passage en irrécouvrable",
  "v9.factures.irrecouvrable.erreur": "Le passage en irrécouvrable n'a pas abouti.",
  "v9.factures.irrecouvrable.irrecouvrable": "Créance passée en irrécouvrable.",
  "v9.factures.irrecouvrable.jeton": "Jeton de confirmation d'identité (seul super-administrateur)",
  "v9.factures.irrecouvrable.motif": "Motif du passage en irrécouvrable (15 caractères au moins)",
  "v9.factures.irrecouvrable.motif_requis": "Le motif doit compter {{min}} caractères au moins.",
  "v9.factures.irrecouvrable.reste_payable": "La créance reste payable et l’impayé suit son calendrier.",
  "v9.factures.issue.accepte": "accepté",
  "v9.factures.issue.gagne": "gagné",
  "v9.factures.issue.ouvert": "ouvert",
  "v9.factures.issue.perdu": "perdu",
  "v9.factures.lien.adresse_invalide": "Saisissez une adresse électronique valide.",
  "v9.factures.lien.bouton": "Envoyer le lien de paiement",
  "v9.factures.lien.destinataire": "Adresse du tiers qui réglera",
  "v9.factures.lien.en_cours": "Envoi…",
  "v9.factures.lien.erreur": "Le lien n'a pas pu être envoyé.",
  "v9.factures.lien.prestataire": "Régler sur la page du prestataire (mobile money)",
  "v9.factures.lien.sans_compte": "Le tiers règle sur la page du prestataire, sans compte DoIt.",
  "v9.factures.lien.succes": "Lien envoyé, valable jusqu'au {{date}}.",
  "v9.factures.liste.aucun_resultat": "Aucune facture ne correspond à la recherche.",
  "v9.factures.liste.vide": "Aucune facture pour cette période.",
  "v9.factures.litige.aucun": "Aucun litige.",
  "v9.factures.litige.echeance": "Échéance de réponse chez le prestataire",
  "v9.factures.litige.effet": "Effet sur l'accès",
  "v9.factures.litige.facture": "Facture",
  "v9.factures.litige.issue": "Issue",
  "v9.factures.litige.lien": "Litige de {{montant}} ({{issue}})",
  "v9.factures.litige.motif": "Motif",
  "v9.factures.litige.preuves": "Fournir les preuves chez le prestataire",
  "v9.factures.litige.retour": "Retour à la facturation de l'organisation",
  "v9.factures.litige.titre": "Litige {{reference}}",
  "v9.factures.litige.titres": "Litiges",
  "v9.factures.moyen.changer": "Changer de moyen de paiement",
  "v9.factures.parametres.calendrier": "Calendrier des impayés",
  "v9.factures.parametres.calendrier_invalide": "Les jours du calendrier vont de 0 à 365.",
  "v9.factures.parametres.emetteur": "Émetteur des factures",
  "v9.factures.parametres.enregistres": "Paramètres enregistrés.",
  "v9.factures.parametres.erreur": "Les paramètres n'ont pas pu être enregistrés.",
  "v9.factures.parametres.fiscalite": "Fiscalité par pays",
  "v9.factures.parametres.fiscalite_aide": "Une règle par ligne : « SN 18 ttc », « FR 20 ht autoliquidation ».",
  "v9.factures.parametres.fiscalite_invalide": "Une règle fiscale est illisible ou son taux dépasse 100.",
  "v9.factures.parametres.grace": "Délai de grâce (jours)",
  "v9.factures.parametres.impayes_futurs": "Un changement du calendrier ne s’applique qu’aux impayés futurs.",
  "v9.factures.parametres.lecture_seule": "Lecture seule (jours)",
  "v9.factures.parametres.mentions": "Mentions légales",
  "v9.factures.parametres.numerotation": "Numérotation",
  "v9.factures.parametres.prefixe": "Préfixe des factures futures",
  "v9.factures.parametres.prefixe_invalide": "Préfixe : 1 à 20 caractères A-Z, 0-9 ou tiret.",
  "v9.factures.parametres.reflexion": "Délai de réflexion de l'auto-approbation (heures, 1 à 168)",
  "v9.factures.parametres.reflexion_invalide": "Le délai de réflexion va de 1 à 168 heures.",
  "v9.factures.parametres.relances": "Relances (jours, séparés par des virgules)",
  "v9.factures.parametres.retour": "Retour aux paramètres de la plateforme",
  "v9.factures.parametres.sequence": "Prochaine séquence",
  "v9.factures.parametres.sequence_avant": "Modifiable jusqu'à la première facture ; ensuite, la séquence reste sans trou.",
  "v9.factures.parametres.sequence_figee": "Séquence figée depuis la première facture : seul le préfixe change.",
  "v9.factures.pdf.bouton": "Télécharger le PDF",
  "v9.factures.pdf.en_cours": "Téléchargement…",
  "v9.factures.pdf.erreur": "Le PDF n'a pas pu être téléchargé.",
  "v9.factures.quoi.abonnement": "l'abonnement",
  "v9.factures.quoi.coordonnees": "les coordonnées de facturation",
  "v9.factures.quoi.documents": "les documents de la plateforme",
  "v9.factures.quoi.facture": "la facture",
  "v9.factures.quoi.factures": "les factures",
  "v9.factures.quoi.litige": "le litige",
  "v9.factures.quoi.parametres": "les paramètres de facturation",
  "v9.factures.raison.exceptions_a_venir": "Demandes d'exception : écran livré par le paquet exceptions (v9-p04).",
  "v9.factures.raison.moyens_a_venir": "Moyens de paiement : écran livré par le paquet abonnement (v9-p02).",
  "v9.factures.raison.parametres_a_venir": "Paramètres de la plateforme : écran livré par la vague V10c.",
  "v9.factures.raison.prestataire_a_venir": "Le dépôt des preuves attend le raccordement du prestataire de paiement réel.",
  "v9.factures.reessayer": "Réessayer",
  "v9.factures.reglement.affectation": "Affectation aux factures",
  "v9.factures.reglement.affectation_invalide": "Une affectation n’est pas un montant valide.",
  "v9.factures.reglement.affectations_superieures": "Les affectations dépassent le montant reçu.",
  "v9.factures.reglement.affecter": "{{numero}} (reste dû {{reste}})",
  "v9.factures.reglement.aucune_facture_due": "Aucune facture due : tout le montant ira au crédit.",
  "v9.factures.reglement.erreur": "Le règlement n'a pas pu être enregistré.",
  "v9.factures.reglement.montant": "Montant reçu",
  "v9.factures.reglement.montant_invalide": "Saisissez un montant positif (deux décimales au plus).",
  "v9.factures.reglement.ouvrir": "Enregistrer un règlement",
  "v9.factures.reglement.piece": "Pièce justificative (facultative)",
  "v9.factures.reglement.recu": "Règlement reçu",
  "v9.factures.reglement.recu_le": "Reçu le",
  "v9.factures.reglement.reference": "Référence (virement, chèque…)",
  "v9.factures.reglement.reference_requise": "La référence est requise.",
  "v9.factures.reglement.retour": "Retour à la facturation de l'organisation",
  "v9.factures.reglement.succes": "Règlement enregistré : reste dû {{reste}}, crédit créé {{credit}}.",
  "v9.factures.reglement.trop_percu": "Le trop-perçu est porté au crédit de l’organisation.",
  "v9.factures.regler.bouton": "Régler maintenant",
  "v9.factures.regler.en_cours": "Paiement en cours…",
  "v9.factures.regler.erreur": "Le paiement n'a pas pu être soumis.",
  "v9.factures.regler.etat.authentification_forte_requise": "Authentification forte demandée chez le prestataire.",
  "v9.factures.regler.etat.confirmation_attendue": "Paiement soumis : confirmation attendue du prestataire.",
  "v9.factures.regler.etat.confirmee": "Paiement confirmé.",
  "v9.factures.regler.etat.resultat_inconnu": "Résultat inconnu : vérification en cours chez le prestataire, ne réglez pas à nouveau.",
  "v9.factures.regler.etat.soumise": "Paiement soumis au prestataire.",
  "v9.factures.regler.retrouvee": "Un paiement de cette facture est déjà en cours : aucun second débit.",
  "v9.factures.retablissement.paiement_confirme_retablissement_en_cours": "Paiement confirmé : rétablissement de l'accès en cours.",
  "v9.factures.retablissement.retabli": "Accès rétabli.",
  "v9.factures.retour_abonnement": "Retour à l'abonnement",
  "v9.factures.retour_factures": "Retour aux factures",
  "v9.factures.statut.avoirs": "Avoirs",
  "v9.factures.statut.impayees_et_en_retard": "Impayées et en retard",
  "v9.factures.statut.payees": "Payées",
  "v9.factures.statut.remboursees": "Remboursées",
  "v9.factures.statut.toutes": "Toutes",
  "v9.factures.verification.invalide": "Identifiant fiscal invalide.",
  "v9.factures.verification.non_verifie": "Identifiant fiscal non vérifié.",
  "v9.factures.verification.non_verifie_taxe_appliquee": "Non vérifié : la taxe est appliquée.",
  "v9.factures.verification.verification_en_cours": "Vérification en cours.",
  "v9.factures.verification.verifie": "Identifiant fiscal vérifié.",
  "v9.factures.voir": "Voir",
  "v9.factures.voir_facture": "Voir la facture {{numero}}"
}
